import React from "react"
import { Container } from "reactstrap"
import EventAnniversary from "components/EventAnniversary"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

const BookEvent = () => {
  const navigate = useNavigate()
  const token = useSelector(state => state.auth.token)
  useEffect(() => {
    if (token === null) {
      navigate("/login", { replace: true })
    }
  }, [])
  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div
        className="container-fluid"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <Container fluid={false}>
          <EventAnniversary />
        </Container>
      </div>
    </div>
  )
}

export default BookEvent
